/* eslint-disable jsx-a11y/anchor-has-content,jsx-a11y/no-static-element-interactions,jsx-a11y/no-noninteractive-element-interactions */
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import TasksManage from 'mt-react-common/modules/tasks/services/TasksManage';
import DefaultSelect from 'components/Common/Inputs/DefaultSelect';
import {
  getItemFromRefList,
  getValueFromRefDataModules
} from 'mt-react-common/modules/main/reducers/static/states/referenceLists/reducer';
import { useLightForm } from 'utils/hooks/useLightForm';
import { addClientNotice } from 'mt-react-common/modules/main/reducers/static/states/clientNotices/reducer';
import './index.css';

const TaskChangeStatusManageModal = props => {
  const { taskModel, isOpen, onClose, onRefreshParentContent } = props;
  const [loading, setLoading] = useState(false);
  const modalId = `blockTask-${taskModel.id}`;
  const lightForm = useLightForm({
    newStatus: null,
    lockReasonId: null
  });

  const taskStatuses = useSelector(state =>
    getItemFromRefList(state, 'taskStatuses')
      .map((title, value) => ({
        value,
        title
      }))
      .filter(
        item =>
          [1, 2, 5, 6, 7].includes(item.value) &&
          item.value !== taskModel.status
      )
  );
  const tasksLocksReasons = useSelector(state =>
    getValueFromRefDataModules(state, 'tasks.tasksLocksReasons').filter(
      item => item.visible === 1
    )
  );
  const dispatch = useDispatch();

  useEffect(() => {
    // eslint-disable-next-line no-undef
    $(`#${modalId}`).modal(isOpen ? 'show' : 'hide');
  }, [isOpen]);

  const fetch = () => {
    setLoading(true);
    TasksManage.changeStatus(taskModel.id, lightForm.fields).then(
      responseModel => {
        // console.log(responseModel);
        if (responseModel && responseModel.status === 200) {
          onClose();
          onRefreshParentContent();
          dispatch(
            addClientNotice({
              type: 'success',
              message: responseModel.data.message
            })
          );
        } else if (responseModel && responseModel.status === 422) {
          lightForm.setErrors(responseModel.data);
        } else if (responseModel && responseModel.status === 403) {
          dispatch(
            addClientNotice({
              type: 'error',
              message: responseModel.data.message
            })
          );
        }
        setLoading(false);
      }
    );
  };

  const errorDesc = fieldName => {
    const errorMessage = lightForm.getFirstFieldError(fieldName);
    if (errorMessage) {
      return <small className="help-block">{errorMessage}</small>;
    }
    return null;
  };

  const isInputDisable = !['5', '7'].includes(
    lightForm.getFieldValue('newStatus')
  );

  return (
    <div
      className="modal fade task-change-status-manage-modal"
      id={modalId}
      role="dialog"
      tabIndex="-1"
      onClick={onClose}
    >
      <div
        className="modal-dialog modal-gray"
        onClick={e => e.stopPropagation()}
      >
        <div className="modal-content">
          <div className="modal-header text-center">
            <a
              aria-label="Close"
              className="close close-black"
              href={null}
              onClick={onClose}
            />
            <i className="fa fa-ban modal-icon" />
            <h4 className="modal-title">
              <strong>
                {`Заблокировать задание "${taskModel.title}", id:${taskModel.id}`}
              </strong>
            </h4>
          </div>
          <div className="modal-body">
            <div className="panel-body">
              <div
                className={classNames('form-group', {
                  'has-error': lightForm.hasFieldError('newStatus')
                })}
              >
                <label className="control-label" htmlFor={'0'}>
                  Новое состояние
                </label>
                <DefaultSelect
                  selectArrItems={taskStatuses}
                  selectTitleNullValue={null}
                  value={lightForm.getFieldValue('newStatus')}
                  handleChangeValue={value =>
                    lightForm.setFieldValue('newStatus', value)
                  }
                  placeholder="Выбирите новое состояния"
                />
                {errorDesc('newStatus')}
              </div>
              <div
                className={classNames('form-group', {
                  'has-error': lightForm.hasFieldError('lockReasonId')
                })}
              >
                <label className="control-label" htmlFor={'0'}>
                  Причина
                </label>
                <DefaultSelect
                  hasDisabled={isInputDisable}
                  selectArrItems={tasksLocksReasons}
                  selectTitleNullValue={null}
                  value={lightForm.getFieldValue('lockReasonId')}
                  handleChangeValue={value =>
                    lightForm.setFieldValue('lockReasonId', value)
                  }
                  placeholder="Выбирите причину"
                />
                {errorDesc('lockReasonId')}
              </div>
              <div
                className={classNames('form-group', {
                  'has-error': lightForm.hasFieldError('lockComment')
                })}
              >
                <label
                  htmlFor="blockTaskTextarea"
                  className="col-sm-2 control-label"
                >
                  Комментарий
                </label>
                <textarea
                  disabled={isInputDisable}
                  value={lightForm.getFieldValue('lockComment')}
                  onChange={e => {
                    lightForm.setFieldValue('lockComment', e.target.value);
                  }}
                  className="form-control"
                  rows="3"
                  id="blockTaskTextarea"
                />
                {errorDesc('lockComment')}
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <a
              className="btn btn-muted"
              data-dismiss="modal"
              href=""
              type="button"
            >
              Отмена
            </a>
            <a
              className={classNames('btn btn-success', {
                disabled: loading
              })}
              href=""
              type="button"
              onClick={e => {
                e.preventDefault();
                fetch();
              }}
            >
              Применить
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

TaskChangeStatusManageModal.defaultProps = {
  isOpen: false,
  onClose: () => {},
  onRefreshParentContent: () => {}
};

TaskChangeStatusManageModal.propTypes = {
  taskModel: PropTypes.shape({
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    status: PropTypes.number.isRequired
  }).isRequired,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onRefreshParentContent: PropTypes.func
};

export default TaskChangeStatusManageModal;



// WEBPACK FOOTER //
// ./src/components/Tasks/_actions/TaskChangeStatusManageModal/index.js